import { useCallback, useState } from "react";
import type { UseChunkedList } from "./types";

// Mounts the list in chunks so a huge scope never lands in the DOM in one commit.
export const useChunkedList: UseChunkedList = ({ items, chunkSize }) => {
  const [mountedCount, setMountedCount] = useState(chunkSize);

  const showMoreItems = useCallback(() => {
    setMountedCount((previous) => previous + chunkSize);
  }, [chunkSize]);

  const visibleItems = items.slice(0, mountedCount);
  const hasMoreItems = visibleItems.length < items.length;

  return { visibleItems, hasMoreItems, showMoreItems };
};
